import CancelAppointmentConfirmationContainer from "../../../routes/confirmation/v3/pages/CancelAppointment/routes/confirmation/CancelAppointmentConfirmationContainer.js";
import CancelAppointmentRoot from "../../../routes/default/v3/pages/CancelAppointment/routes/default/CancelAppointmentRoot.js";
const routeMap = {
  "": CancelAppointmentRoot,
  confirmation: CancelAppointmentConfirmationContainer
};
export {
  routeMap
};
//# sourceMappingURL=route-map.js.map
